/**
 * Рука A/B-теста масштаба поля на клиенте (MADR 0036). Руку назначает сервер и отдаёт в профиле; пока
 * вход не прошёл, берётся прошлая рука с этого устройства, чтобы вернувшийся игрок не видел скачка камеры. `?scale=a|g`
 * (только локальный хост, `debug-params.ts`) — для e2e и макетов.
 */
import type { FieldScale, PlayerState } from "@newfungame/contracts";

export const FIELD_SCALE_KEY = "nfg:fieldScale";

const isScale = (v: unknown): v is FieldScale => v === "a" || v === "b";

export function currentFieldScale(
  player: PlayerState | null,
  forced: string | null,
  storage: Pick<Storage, "getItem"> | null,
): FieldScale {
  if (isScale(forced)) return forced;
  if (player) return player.player.fieldScale;
  try {
    const stored = storage?.getItem(FIELD_SCALE_KEY);
    return isScale(stored) ? stored : "a";
  } catch {
    return "a";
  }
}

/** Запомнить руку вошедшего игрока для следующего открытия. */
export function rememberFieldScale(scale: FieldScale, storage: Pick<Storage, "setItem"> | null): void {
  try {
    storage?.setItem(FIELD_SCALE_KEY, scale);
  } catch {
    // приватный режим: без запоминания
  }
}
